import common from "./en-US/common"
import home from "./en-US/home"
import query from './en-US/query'
import track from './en-US/track'
import contact from './en-US/contact'
import about from './en-US/about'

export default {
    ...common,
    ...home,
    ...about,
    ...query,
    ...track,
    ...contact
}